export const timeoutFunc = (timeout, action, delay) => {
  clearTimeout(timeout);
  return setTimeout(() => {
    action();
  }, delay);
};

export const getNickName = (name) => {
  if (name) {
    return name[0].toUpperCase() + name[name.length - 1]?.toUpperCase();
  }
  const x = name?.match(/\b\w/g) || [];
  return ((x.shift() || '') + (x.pop() || '')).toUpperCase();
};

export function numberFormatter(x) {
  if (x !== null && x !== undefined) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  return x;
}

export function decimalFormatter(x) {
  if (x !== null && x !== undefined) {
    // integer
    if (Number.isInteger(x)) {
      return x
        .toString()
        .replace(/\./g, ',')
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    // decimal
    if (x % 1 !== 0) {
      try {
        return x
          .toFixed(2)
          .toString()
          .replace(/\./g, ',')
          .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      } catch {
        return x.replace(/\./g, ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }
    }

    try {
      return x.replace(/\./g, ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    } catch {
      return x.toFixed(2);
    }
  }
  return 0;
}

export function toRupiah(x) {
  if (x) {
    return `Rp ${decimalFormatter(x)}`;
  }
  return '-';
}
export function toCurrency(x, currency) {
  if (x) {
    return `${currency} ${decimalFormatter(x)}`;
  }
  return '-';
}
export function toIDR(x) {
  return `IDR ${decimalFormatter(x)}`;
}

export const isObjectEmpty = (value) => {
  return (
    Object.prototype.toString.call(value) === '[object Object]' &&
    JSON.stringify(value) === '{}'
  );
};

export const byteToSize = (bytes, decimals = 0) => {
  if (bytes === 0) return '0 Bytes';
  const formatted = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB'];
  const calculate = Math.floor(Math.log(bytes) / Math.log(formatted));

  return `${parseFloat((bytes / formatted ** calculate).toFixed(dm))} ${
    sizes[calculate]
  }`;
};

export const sortTable = (sorter) => {
  const sortData = sorter.constructor === Object ? [sorter] : sorter;
  if (sortData.length === 1 && !sortData[0].order) return null;
  const initialValue = {};
  sortData.sort().forEach((item) => {
    const key = item.field;
    const value = item.order === 'ascend' ? 'ASC' : 'DESC';
    initialValue[key] = value;
  });
  return initialValue;
};

export const sortVariables = (sort) => {
  const orderDict = {
    ascend: 'ASC',
    descend: 'DESC',
  };
  const initialValue = {};
  if (Array.isArray(sort)) {
    sort.forEach((a) => {
      Object.assign(initialValue, {
        [a.field]: orderDict[a.order],
      });
    });
  } else if (sort?.field && sort?.order) {
    Object.assign(initialValue, {
      [sort.field]: orderDict[sort.order],
    });
  } else {
    return undefined;
  }
  return initialValue;
};

export const updateSorter = (defaultSort, sort) => {
  if (sortVariables(sort)) {
    return sortVariables(sort);
  }
  return { ...defaultSort };
};

export const filterEmptyObject = (value) => {
  const data = {};
  Object.keys(value).forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(value, key)) {
      if (value[key]) {
        data[key] = value[key];
      }
    }
  });
  return data;
};

export const validateEmail = (email) => {
  const re =
    // eslint-disable-next-line max-len
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

export const validatePhoneNumber = (number) => {
  const numberRegex = new RegExp(/^[0-9]{8,}\d*$/, 'g');
  return numberRegex.test(number);
};

export const validateNominal = (nominal) => {
  const nominalRegex = new RegExp(/^[1-9]\d*$/, 'g');
  return nominalRegex.test(nominal);
};

export const analyzerAdvFilterToArray = (searchQuery) => {
  const array = Object.keys(searchQuery).map((key) => {
    return { filterName: key, filterValue: searchQuery[key] };
  });
  return array;
};

export const onInputNumber = (event) => {
  if (
    !/[0-9]/.test(event.key) &&
    event.key !== 'Backspace' &&
    event.key !== '.' &&
    event.key !== 'Tab'
  ) {
    event.preventDefault();
  }
};

export const getLastSubId = (id = '') => {
  const splittedId = id.split('-');
  return splittedId[4];
};

export const compareTwoArrays = ({ array1, array2 }) => {
  const array2Sorted = array2.slice().sort();
  return (
    array1.length === array2.length &&
    array1
      .slice()
      .sort()
      .every((value, index) => {
        return value === array2Sorted[index];
      })
  );
};

export const pluralWriter = ({ value, word }) => {
  if (value > 1) {
    return `${word}s`;
  }
  return word;
};

export const isValidURL = (url) => {
  const res = url?.match(
    // eslint-disable-next-line no-useless-escape
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
  );
  return res !== null;
};

export const getUsernameSocialAccount = (url) => {
  const parts = url?.split('/');
  return parts?.pop();
};

export const getFormatCurrency = ({ currency, value }) => {
  if (!value || !currency) return '';
  const formatter = new Intl.NumberFormat('es-US', {
    style: 'currency',
    currency,
  });
  return formatter.format(value);
};

export const getUrlFromTag = (tag) => {
  const pattern =
    // eslint-disable-next-line max-len
    /(?:(?:https?|ftp):\/\/|\b(?:[a-z\d]+\.))(?:(?:[^\s()<>]+|\((?:[^\s()<>]+|(?:\([^\s()<>]+\)))?\))+(?:\((?:[^\s()<>]+|(?:\(?:[^\s()<>]+\)))?\)|[^\s`!()[\]{};:'".,<>?«»“”‘’]))?/;
  return tag?.match(pattern) || [];
};

export function numberFormatterPlural(x) {
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  const lookup = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'K' },
    { value: 1e6, symbol: 'M' },
    { value: 1e9, symbol: 'G' },
    { value: 1e12, symbol: 'T' },
    { value: 1e15, symbol: 'P' },
    { value: 1e18, symbol: 'E' },
  ];
  if (x !== null && x !== undefined) {
    const items = lookup
      .slice()
      .reverse()
      .find((item) => {
        return x >= item?.value;
      });
    return items
      ? (x / items.value).toFixed(1).replace(rx, '$1') + items.symbol
      : '0';
  }
  return x;
}

export function validClassNameColumn({ isValid, className }) {
  let res = className;
  if (isValid) {
    res += ' black2';
  }
  if (!isValid) {
    res += ' red1';
  }
  return res;
}

export function isHttpExist(params) {
  const re = new RegExp('^(http|https)://', 'i');

  return re.test(params);
}

export function urlFormatter(params) {
  if (isHttpExist(params)) {
    return params;
  }
  return `http://${params}`;
}

export const groupArrayOfObject = (arr = [], key) => {
  return arr.reduce((prev, curr) => {
    (prev[curr[key]] = prev[curr[key]] || []).push(curr);
    return prev;
  }, {});
};
